/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_Available_BodyInputs */



/**
* | output |
* | --- |
* | "A new version of Closed Caption Creator is available." |
*
* @param {Update_Available_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_available_body = /** @type {((inputs?: Update_Available_BodyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_Available_BodyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une nouvelle version de Closed Caption Creator est disponible.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine neue Version von Closed Caption Creator ist verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È disponibile una nuova versione di Closed Caption Creator.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступна новая версия программы для создания субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya está disponible una nueva versión de Closed Caption Creator.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新版字幕创建工具现已推出。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Closed Caption Creator の新しいバージョンが利用可能です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन क्रिएटर का नया संस्करण उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Uma nova versão do Closed Caption Creator está disponível.")
	return /** @type {LocalizedString} */ ("A new version of Closed Caption Creator is available.")
});